export default __webpack_public_path__ + "static/media/Comp 2_00017.bab3c97a.png";